/* import __COLOCATED_TEMPLATE__ from './spare-single.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type { OpAmpItem } from './spares-container';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type OpampService from '../../services/opamps';

interface SpareSingleStageCircuitArgs {
  circuitValues: OpAmpItem;
  index: number;
}

export default class SpareSingleStageCircuit extends Component<SpareSingleStageCircuitArgs> {
  @service('aditools-site') declare siteconfig: SiteService;
  @service declare opamps: OpampService;

  yTranslate = 0;

  get xTranslate(): number {
    return this.args.index * 100;
  }

  get url(): string {
    return `${this.siteconfig['SiteUrl']}/${this.siteconfig.AdiLocale}/${this.opamps
      .getOpAmp(this.args.circuitValues.name)
      .generic.toUpperCase()}`;
  }
}
